<div
  class="rounded-2xl border-l-8 border-blue-primary bg-gray-5 p-5 shadow-lg"
  [ngClass]="selected() ? 'border-blue-primary' : 'border-gray-2'"
>
  <div class="flex items-center justify-between">
    <div class="flex w-10/12 flex-col gap-2">
      <div class="flex">
        <span class="w-3/12 text-gray-2">ПІБ Лікаря</span>
        <span class="w-8/12">{{ eleksVisitData().doctorName }}</span>
      </div>

      <div class="flex">
        <span class="w-3/12 text-gray-2">Адреса</span>
        <span class="w-8/12">
          {{ eleksVisitData()?.location }}
        </span>
      </div>

      <div class="flex">
        <span class="w-3/12 text-gray-2">Дата та час візиту</span>
        <span class="w-8/12">
          {{ formatDate(eleksVisitData().startDate, true) }}
          - {{ eleksVisitData().endDate | date: "HH:mm" }}
        </span>
      </div>
    </div>

    <div class="flex w-2/12 items-center justify-end">
      @if (!selected()) {
        <button
          class="btn btn-primary text-sm"
          (click)="selectEleksVisit(true)"
        >
          Обрати
        </button>
      } @else {
        <button
          class="flex items-center justify-center rounded-full bg-blue-primary p-2 text-gray-5"
          (click)="selectEleksVisit(false)"
        >
          <mat-icon>done</mat-icon>
        </button>
      }
    </div>
  </div>
</div>
